import EntityWithNameStore from "./EntityWithNameStore"

class UserStore extends EntityWithNameStore
{
    getEntityName(user)
    {
        return user.formatNameLFMU()
    }
}

const userStore = new UserStore();
export default userStore;


// WEBPACK FOOTER //
// ./web/js/store/userStore.js